import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sfg-archive-purge',
  templateUrl: './sfg-archive-purge.component.html',
  styleUrls: ['./sfg-archive-purge.component.css']
})
export class SfgArchivePurgeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
